import React from "react";

export default class Constants extends React.Component {
    static apisFolder = '/apis_test/'; 
    static ipAddress = '80.211.238.132';
    static mainUrl = '80.211.238.132' + Constants.apisFolder;
}